import React from 'react';

const SvgChevronBack = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.725 5.5L7 11.999l7.725 6.501L16 17.041 10.011 12 16 6.959z",
  fillRule: "evenodd"
}));

export default SvgChevronBack;